import { SuprimentosService } from './../../../services/suprimentos/suprimentos.service';
import { Subscription } from 'rxjs';
import { IListarSuprimentoDetalhes } from 'src/app/interfaces/suprimentos/IListarSuprimentoDetalhes';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-suprimentos-detalhes-do-pedido',
  templateUrl: './suprimentos-detalhes-do-pedido.component.html',
  styleUrls: ['./suprimentos-detalhes-do-pedido.component.scss']
})
export class SuprimentosDetalhesDoPedidoComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  detalhesPedido: IListarSuprimentoDetalhes;
  codPedido: string;

  constructor(
    private service: SuprimentosService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.codPedido = this.activatedRoute.snapshot.params.codOrcamento;
    this.getPedidosSuprimentosDetalhes();
  }

  getPedidosSuprimentosDetalhes() {
    this.subscriptions$.add(
      this.service
        .getSuprimentosChamadoDetalhes(this.codPedido) //'I00304'
        .subscribe({
          next: ({ data }) => {
            this.detalhesPedido = data;
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
